import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2423b258&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2423b258&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423b258",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2423b258')) {
      api.createRecord('2423b258', component.options)
    } else {
      api.reload('2423b258', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2423b258&scoped=true", function () {
      api.rerender('2423b258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configManage/authority/index.vue"
export default component.exports